var _style, _g, _g2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-bin_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-bin_svg__st0{opacity:.5}.icon-bin_svg__st1{fill:#050505}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-bin_svg__st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-bin_svg__st1",
    d: "M14.2 19.4c-.6 0-1-.4-1-1V8.8c0-.6.4-1 1-1s1 .4 1 1v9.5c0 .6-.4 1.1-1 1.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "icon-bin_svg__st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-bin_svg__st1",
    d: "M9.6 19.4c-.6 0-1-.4-1-1V8.8c0-.6.4-1 1-1s1 .4 1 1v9.5c0 .6-.4 1.1-1 1.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-bin_svg__st1",
    d: "M21.7 4h-2.8v-.5c0-1.4-1.1-2.5-2.5-2.5H7.6C6.2 1 5.1 2.1 5.1 3.5V4H2.3c-.5 0-1 .4-1 1s.5 1 1 1h1.2v14.6c0 1.4 1.1 2.5 2.5 2.5h11.9c1.4 0 2.5-1.1 2.5-2.5V6h1.2c.5 0 1-.4 1-1 .1-.6-.4-1-.9-1zM7.1 3.5c0-.3.2-.5.5-.5h8.8c.3 0 .5.2.5.5V4H7.1v-.5zm11.3 17c0 .3-.2.5-.5.5H6.1c-.3 0-.5-.2-.5-.5V6h12.8v14.5z"
  })));
}

export default SvgIconBin;